export default __webpack_public_path__ + "static/media/cactus.61e35538.jpg";